import { connect } from "react-redux";

import { selectDisplayedPages } from "~/store/selectors/page";
import {
  addBookmark,
  removeBookmark,
  selectHasBookmarkOnPage
} from "~/store/ducks/user/bookmarks";
import { showModal } from "~/store/ducks/domain/ui/modal";
import {
  moveMaterial,
  updateMaterialPositions,
  selectMaterialGroupsByPagesByTypes
} from "~/store/ducks/application/materials/materials";
import { selectMarginalLayerHeight } from "~/store/ducks/domain/ui/marginalLayer";
import { selectShowBookmarksTab } from "~/store/ducks/domain/ui/sidebarLeft";
import { selectRightSidebarActiveItems } from "~/store/ducks/user/uistate";

import MaterialLayer from "./MaterialLayer";

function mapStateToProps(state, { page }) {
  const activeItems = selectRightSidebarActiveItems(state);

  return {
    isBookmarked: selectHasBookmarkOnPage(page)(state),
    bookmarksEnabled: selectShowBookmarksTab(state),
    materials: selectMaterialGroupsByPagesByTypes([page])(activeItems)(state),
    marginalLayerHeight: selectMarginalLayerHeight(state),
    activePages: selectDisplayedPages(state)
  };
}

const mapDispatchToProps = {
  showModal,
  moveMaterial,
  updateMaterialPositions,
  addBookmark,
  removeBookmark
};

export default connect(mapStateToProps, mapDispatchToProps)(MaterialLayer);
